import axios from "axios";
import { ADMIN_ROLES, COMMON_CONSTANTS, NUMBER_CONSTANTS, STORAGE_KEYS } from "../../Utilities/Constants/Constants";
import { REGEX } from "../../Utilities/Constants/Validations";
import AWS from "aws-sdk";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";

/** store data in session storage */
const SetSessionStorageData = (sessionKey: string, payload: any) => {
  return sessionStorage.setItem(sessionKey, payload);
};

/** get data from session storage */
const GetSessionStorageData = (sessionKey: string) => {
  return sessionStorage.getItem(sessionKey);
};
/** check for null, undefined and empty value */
const nullUndefinedEmptyCheck = (data: any) => {
  return data != null && data !== undefined && data !== "" && data !== " ";
};

const checkValueNullUndefinedEmpty = (data: any) => {
  return data === null || data === undefined || data === "";
}

/* To clear sessin storage */
const clearSessionStorage = () => {
  return sessionStorage.clear();
}

/* Clear particular key in session storage*/
const clearSessionKey = (key: any) => {
  return sessionStorage.removeItem(key);
}

/* To validate only english on enter */
const validateEnglish = (e: any) => {
  if (REGEX.ENGLISH_INPUT_VALIDATION.test(e.target.value) && !/[0-9.,]/.test(e.key)) {
    return true;
  } else {
    e.preventDefault();
    return;
  }


};

/* Restricting Number only inputs */
const numberOnly = (event: any) => {
  const input = event.target;
  const value = input.value;

  // Remove non-digit and non-decimal characters except the first dot
  const sanitizedValue = value.replace(/[^\d.]/g, (match: any, offset: any) => {
    if (match === COMMON_CONSTANTS.DOT && offset === NUMBER_CONSTANTS.ZERO) {
      return match;
    }
    return "";
  });

  // Limit to two digits after the decimal point
  const decimalIndex = sanitizedValue.indexOf(".");
  if (decimalIndex !== NUMBER_CONSTANTS.MINUS_ONE && sanitizedValue.length - decimalIndex > NUMBER_CONSTANTS.TWO + NUMBER_CONSTANTS.ONE) {
    input.value = sanitizedValue.slice(NUMBER_CONSTANTS.ZERO, decimalIndex + NUMBER_CONSTANTS.THREE);
  } else {
    input.value = sanitizedValue;
  }
};

/* To restrict inputs for only numbers and two numbers after decimal points */
const numberOnlyWithDecimal = (event: any) => {
  const input = event.target;
  let value = input.value;

  // Remove non-digit and non-decimal characters except the first dot
  const sanitizedValue = value.replace(
    /[^0-9.]/g,
    (match: any, offset: any) => {
      if (match === "." && offset === 0) {
        return match;
      }
      return "";
    }
  );

  // Limit to two digits after the decimal point
  const decimalIndex = sanitizedValue.indexOf(".");
  if (decimalIndex !== -1) {
    const decimalPart = sanitizedValue.substring(decimalIndex + 1);
    if (decimalPart.length > 2) {
      value = sanitizedValue.slice(0, decimalIndex + 3);
    } else {
      value = sanitizedValue;
    }
  } else {
    value = sanitizedValue;
  }

  // Update the input value
  input.value = value;

  // Set the state or perform any other necessary actions
  // For example, you can store the sanitized value in the component state
  // this.setState({ inputValue: value });
};

/* Uploading media to AWS s3 */
const uploadFileToS3 = (file: any, credValue: any) => {
  return new Promise((resolve, reject) => {
    AWS.config.update({
      accessKeyId: atob(credValue[0]?.value),
      secretAccessKey: atob(credValue[1]?.value),
      region: process.env.REACT_APP_S3_REGION,
    });

    const s3 = new AWS.S3();
    let splittedValue: any = file?.name.split(' ');
    const params: any = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      Key: splittedValue.length > NUMBER_CONSTANTS.ONE ? splittedValue.join(COMMON_CONSTANTS.UNDER_SCORE) : file?.name,
      Body: file,
      ACL: COMMON_CONSTANTS.PUBLIC_READ,
      ContentType: file?.type,
    };

    s3.upload(params, (err: any, data: any) => {
      if (err) {
        reject(err);
      } else {
        resolve(data.Location);
      }
    });
  });
};

/* Uploading media to backend Api */
export const S3DataGetApi = async (event: any) => {
  // Check if event.target and event.target.files are defined
  const targetFiles = event?.target?.files;
  // Check if event.dataTransfer and event.dataTransfer.files are defined
  const dataTransferFiles = event?.dataTransfer?.files;
  let file;
  if (targetFiles && targetFiles.length > 0) {
    file = targetFiles[0];
  } else if (dataTransferFiles && dataTransferFiles.length > 0) {
    file = dataTransferFiles[0];
  } else {
    console.error('No files found in event', event);
    return; // Exit the function if no file is found
  }
  const formData = new FormData();
  formData.append('file', file);
  const url = `${process.env.REACT_APP_BASE_BACKEND_API_URL}${API_END_POINTS.S3_STATIC_UPLOAD}`;
  try {
    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response?.data?.result?.data[0];
  } catch (error) { }
};

const applyUserBasedTheme = () => {
  let roleId: any = GetSessionStorageData(STORAGE_KEYS.ROLE);
  switch (roleId) {

    case ADMIN_ROLES.TUTOR:
      setUserTheme({
        primaryColorLight: "#D1E9FF",
        primaryColorDark: "#178FFF"
      });
      break;

    case (ADMIN_ROLES.RECREATIONAL_CAMP):
      setUserTheme({
        primaryColorLight: "#FFEFDC",
        primaryColorDark: "#E88818"
      });
      break;

    case (ADMIN_ROLES.RECREATIONAL_PERSONAL):
      setUserTheme({
        primaryColorLight: "#FFEFDC",
        primaryColorDark: "#E88818"
      });
      break;

    case (ADMIN_ROLES.SCHOOL):
      setUserTheme({
        primaryColorLight: "#FFF4D0",
        primaryColorDark: "#D6A703"
      });
      break;

    case (ADMIN_ROLES.UNIVERSITY):
      setUserTheme({
        primaryColorLight: "#D0F5E9",
        primaryColorDark: "#0CA676"
      });
      break;

  }
};

const setUserTheme = (theme: any) => {
  document.documentElement.style.setProperty('--primaryColorLight', theme.primaryColorLight);
  document.documentElement.style.setProperty('--primaryColorDark', theme.primaryColorDark);
};

/**empty length check */
const checkEmpty = (data: any): boolean => {
  return data.length !== 0;
};

export {
  SetSessionStorageData,
  GetSessionStorageData,
  nullUndefinedEmptyCheck,
  checkValueNullUndefinedEmpty,
  clearSessionStorage,
  validateEnglish,
  uploadFileToS3,
  clearSessionKey,
  numberOnly,
  numberOnlyWithDecimal,
  applyUserBasedTheme,
  checkEmpty
};
